import * as React from 'react';
import {connect} from "react-redux";
import {CONTACT_TAB} from '../../../Config/appConfig';
import {Auth, Company, CompanyHistory, CompanyId, Email, User, InviteUser, Option} from '../../../Config/dataModel';
import userManagementDispatch from '../../../ReduxRequests/Dispatch/userManagementDispatch';
import authState from '../../../ReduxRequests/State/authState';
import userManagementState from '../../../ReduxRequests/State/userManagementState';
import util from '../../../Util/util';
import CloseButton from '../../Custom/CloseButton';
import ContactTab from '../Tab/ContactTab';
import InvitationTableView from '../Invitation/InvitationTableView';
import {clearErrors, assertTrue, assertAllTrue} from '../../../Util/errorUtil';
import ErrorHandler from '../../ErrorHandler/ErrorHandler';
import * as moment from 'moment';
import '../../../style/invitation.css';

const pageSpinner = require('../../../resource/img/page-loading.gif');

const mapStateToProps = (state) => {
    return {
        ...userManagementState(state),
        ...authState(state)
    }
};

interface ApiUserListProps {
    currentTab: string,
    fetchAllApiUsers?: () => void,
    allApiUsers?: any
}

interface ApiUserListState {
    users: User[],
    loading: boolean,
    updatedTime: moment.Moment
}

class ApiUserList extends React.Component <ApiUserListProps, ApiUserListState> {
    public constructor(props: ApiUserListProps) {
        super(props);
        this.state = {
            users: [],
            loading: true,
            updatedTime: null
        };
    }

    componentDidMount() {
        this.props.fetchAllApiUsers();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.allApiUsers !== this.props.allApiUsers) {
            this.setState({
                users: nextProps.allApiUsers,
                loading: false
            });
        }
    }

    changeUpdatedTime(updatedTime: moment.Moment) {
        this.setState({
            updatedTime
        });
    }

    render() {
        return (
            <div className="cmHorCenter cmFormContainer">
                <div className="cmFormTitleHeader">
                    <ContactTab currentTab={this.props.currentTab} updatedTime={this.state.updatedTime} changeUpdateStatus={() => this.changeUpdatedTime(null)}/>
                    <CloseButton/>
                </div>
                {this.state.loading ?
                    <img className="cmCenter" src={pageSpinner}/> :
                    <InvitationTableView
                        currentTab={this.props.currentTab}
                        users={this.state.users}/>}
            </div>
        );
    }
}

export default connect<any, any, ApiUserListProps>(mapStateToProps, userManagementDispatch)(ApiUserList);



// WEBPACK FOOTER //
// ./src/Components/Contact/CompanyList/ApiUserList.tsx